<template>
  <div class="header">
    <div class="header__inner">
      <div
        class="flex justify-center items-center text-iconColor max-w-[90px] lg:max-w-full"
        style="mix-blend-mode: color">
        <div class="text-foregroundPrimary cursor-pointer" @click="handleLogoClick">
          <SezusMainLogo />
        </div>
      </div>
      <div class="flex" v-if="isUserAuth && userdata">
        <router-link class="header__settings flex cursor-pointer" :to="createUserRoute()">
          <BaseAvatar
            :storage-id="userdata?.avatarFile?.storageId"
            :href="createUserRoute()"
            :isAdmin="isAdmin"
            :verified="userdata?.verified" />
          <div class="flex justify-center items-center w-3 mr-[4px] ml-2 text-iconColor">
            <PointsIcon />
          </div>
          <span class="header__rating">{{ abbreviateNumber(userdata?.rating, 'short') }}</span>
          <div class="flex justify-center items-center header-arrow w-4 text-iconColor">
            <ArrowRightIcon />
          </div>
        </router-link>
        <div
          @click="toNotifications"
          class="flex justify-center items-center ml-[12px] cursor-pointer text-iconColor02">
          <MsgNotificationIcon :showRedDot="hasUnreadNotification" />
        </div>
        <ColorSchemeSwitcher />
      </div>
      <div class="hidden sm:flex xl:hidden" v-else>
        <BaseButton style="margin-right: 10px" @click="logIn">Sign in</BaseButton>
        <BaseButton class="max-w-[100px]" @click="signUp">Sign up</BaseButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import { RouterLink, routerViewLocationKey, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import ColorSchemeSwitcher from '@/components/ColorSchemeSwitcher/index.vue';
import ArrowRightIcon from '@/components/Icons/ArrowRightIcon.vue';
import HomeIcon from '@/components/Icons/HomeIcon.vue';
import MsgNotificationIcon from '@/components/Icons/MsgNotificationIcon.vue';
import PointsIcon from '@/components/Icons/PointsIcon.vue';
import SezusMainLogo from '@/components/Icons/SezusMainLogo.vue';
import eventBus from '@/utils/eventBus';
import { scrollToTop } from '@/utils/scrollControl';
import { abbreviateNumber } from '@/utils/utils.js';

const store = useStore();
const router = useRouter();
const userdata = computed(() => store.getters.getUser);
const isUserAuth = computed(() => store.getters.getAuthStatus);
const isShowModal = value => store.dispatch('showModal', value);
const isAdmin = computed(() => userdata?.value?.roles?.includes('admin') || false);

const unreadNotificationsCount = computed(() => store.getters.getUnreadNotificationsCount);

const hasUnreadNotification = computed(() => {
  const newNotificationsCount = store.getters.getUnreadNotificationsCount;
  return newNotificationsCount > 0;
});

const createUserRoute = () => {
  return !userdata.value?.username ? `/profile/${userdata.value?.id}` : `/user/${userdata.value?.username}`;
};

const show = () => {
  isShowModal(true);
};
const toHome = () => {
  eventBus.emit('set-default-tab');
  return '/';
};

const toNotifications = () => {
  router.push('/notifications');
};

const toProfile = () => {
  if (userdata.value && userdata.value.id) {
    router.push(`/profile/${userdata.value.id}`);
  } else {
    console.error('User ID is missing');
  }
};
const logIn = () => {
  router.push('/sign-in');
  localStorage.removeItem('activeTab');
};
const signUp = () => {
  router.push('/onboarding/login-method');
};

const handleLogoClick = () => {
  console.log('Logo clicked');
  router.push(toHome());
};

// const notificationImg = () => {
//   const newNotificationsCount =
//     store.getters.getAllNotifications?.filter((item) => !item.read).length || 0;

//   if(newNotificationsCount > 0) {
//     return "/icon/msg-unread.svg";
//   }else {
//     return "/icon/msg-unread.svg";
//   }
// };
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  display: flex;
  align-items: center;
  width: 100%;
  height: 80px;
  max-height: 80px;
  max-width: 1280px;
  padding: 16px 0;
  z-index: 120;
  background: var(--background-primary);
  //box-shadow: 0px 4px 6px -1px #00000040;

  &__inner {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    isolation: isolate;
  }

  &__rating {
    font-family: $clash;
    color: var(--foreground-primary);
  }

  &__settings {
    display: flex;
    align-items: center;

    &:hover .header-arrow {
      transform: translateX(2px);
    }
  }

  @include _1400 {
    padding: 16px 20px;
  }

  @include _1279 {
    height: 64px;
    padding: 16px 48px;
  }

  @include _1024 {
    padding: 16px 44px;

    img {
      max-width: 90px;
    }
  }

  @include _767 {
    padding: 16px 32px;
  }

  @include _575 {
    padding: 16px;
  }
}

.header-arrow {
  transition: 0.2s ease-in-out;
  width: 7px;
  margin-left: 4px;
}
</style>
